import React from 'react'
import styled from '@emotion/styled'
import { Form, Input } from 'stylist'
import { commaify } from 'utils'

// Only allow values with digits + commas up to 999,999,999
const isAllowed = value => /^[\d,]{0,11}$/.test(value)

const IntegerInput = props => (
  <Form.Field
    name={props.name}
    render={({ value, setValue, renderError }) => (
      <React.Fragment>
        <Input
          {...props}
          onChange={event => {
            if (isAllowed(event.target.value)) {
              setValue(parseInt(event.target.value.replace(/,/g, ''), 10) || '')
              if (props.onChange) {
                props.onChange(event)
              }
            }
          }}
          value={commaify(value)}
        />
        {renderError()}
      </React.Fragment>
    )}
  />
)

export default styled(IntegerInput)`
  text-align: center;
`



// WEBPACK FOOTER //
// ./src/components/IntegerInput.js